<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.emailGroupManagementDetail") }}</h4>
    </div>
    <div class="brick_box">
      <table class="mgt_tbl mgb_0">
        <colgroup>
          <col style="width: 15%" />
          <col style="width: 35%" />
          <col style="width: 15%" />
          <col style="" />
        </colgroup>
        <tbody>
          <tr>
            <th>{{ $t("management.groupName") }}</th>
            <td>
              <input
                type="text"
                v-model="emailGroup.groupName"
                name="groupName"
                v-validate="'required'"
                class="int_type01"
              />
            </td>
            <th>{{ $t("management.useYN") }}</th>
            <td>
              <label class="m-1"
                ><input
                  type="radio"
                  name="useYn"
                  v-model="emailGroup.useYn"
                  value="Y"
                /><span>Yes</span></label
              >
              <label class="m-1"
                ><input
                  type="radio"
                  name="useYn"
                  v-model="emailGroup.useYn"
                  value="N"
                /><span>No</span></label
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="bottom_bt_box">
        <router-link
          to="/management/email/group"
          class="btn btn-outline-dark btn-sm m-1"
          >{{ $t("common.list") }}</router-link
        >
        <button type="button" @click="saveEmailGroup" class="btn btn-primary btn-sm m-1">
          {{ $t("common.edit") }}
        </button>
      </div>
    </div>
    <!--------------------------------  User 변경 저장 --------------------------------------------------------->

    <!-----------------------------------  User  -------------------------------------------------->
    <div class="management_top_box">
      <h4>{{ $t("management.emailGroupUsers") }}</h4>
    </div>

    <div class="brick_box">
      <table class="list_tbl" style="text-align: left">
        <thead>
          <tr>
            <th class="mobile_h">
              <input
                type="checkbox"
                v-model="checkUserAll"
                @click="goUserCheckAll($event.target.checked)"
              />
            </th>
            <th class="mobile_row">{{ $t("management.id") }}</th>
            <th class="mobile_row">{{ $t("common.name") }}</th>
            <th class="mobile_row">{{ $t("signup.email") }}</th>
          </tr>
        </thead>
        <tbody v-if="groupUserList != null">
          <tr v-for="(user, index) in groupUserList" :key="index">
            <td>
              <input type="checkbox" v-model="user.selected" />
            </td>
            <td :id="user.userId">{{ user.loginId }}</td>
            <td>{{ user.userName }}</td>
            <td>{{ user.emailAddress }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">{{ $t("common.noData") }}</td>
          </tr>
        </tbody>
      </table>

      <div class="p-2" style="text-align: right">
        <button type="button" @click="addGroupUser" class="btn btn-primary btn-md m-1">
          {{ $t("common.add") }}
        </button>
        <button type="button" @click="saveGroupUser" class="btn btn-primary btn-md m-1">
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="deleteGroupUser"
          class="btn btn-secondary btn-md m-1"
        >
          {{ $t("common.delete") }}
        </button>
      </div>
    </div>

    <!---------------------------------User 추가------------------------------------------->
    <CommonModal id="memModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("management.addUser") }}</h3>
      </template>
      <template slot="body">
        <div class="list_top_box">
          <div class="float-end">
            <div class="list_top_search d-flex">
              <select
                class="int_type01"
                v-model="form.searchType"
                aria-label="sort select"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option value="loginId">{{ $t("management.id") }}</option>
                <option value="userName">{{ $t("common.name") }}</option>
              </select>
              <input
                type="text"
                v-model="form.searchWord"
                name="userName"
                class="m-1 form-control"
              />
              <button type="button" @click="searchBtn" class="btn btn-primary btn-lg">
                {{ $t("common.search") }}
              </button>
            </div>
          </div>
        </div>
        <div>
          <p>* {{ $t("management.youcannotaddAppUser") }}</p>
        </div>
        <table class="list_tbl inner_tb">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  @click="goCheckAll($event.target.checked)"
                  class="form-check-input"
                  v-model="checkAll"
                />
              </th>
              <th class="mobile_h">{{ $t("management.id") }}</th>
              <th class="mobile_h">{{ $t("signup.name") }}</th>
              <th class="mobile_h">{{ $t("signup.email") }}</th>
            </tr>
          </thead>
          <tbody v-if="mgmtUser.length != 0">
            <tr v-for="(item, index) in mgmtUser" :key="index">
              <td>
                <input type="checkbox" v-model="item.selected" class="form-check-input" />
              </td>
              <td>{{ item.loginId }}</td>
              <td>{{ item.userName }}</td>
              <td>{{ item.emailAddress }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4">{{ $t("common.noData") }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="mgmtUser.length != 0" class="paging_nav">
          <div class="paging_nav">
            <a
              href="javascript:void(0)"
              v-if="pagingVO.startPage <= pagingVO.blockSize"
              class="page_select prev_page disabled"
              >이전페이지 이동</a
            >
            <a
              v-else
              class="page_select prev_page"
              @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
              v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
              >이전페이지 이동</a
            >
            <span
              v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
              :key="index"
            >
              <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
                pagingVO.startPage + index
              }}</strong>
              <a
                href="javascript:void(0)"
                v-else
                @click="searchPage(pagingVO.startPage + index)"
                >{{ pagingVO.startPage + index }}</a
              >
            </span>
            <a
              v-if="pagingVO.endPage >= pagingVO.totalPage"
              href="javascript:void(0)"
              class="page_select next_page disabled"
              >다음페이지 이동</a
            >
            <a
              v-else
              href="javascript:void(0)"
              @click="searchPage(pagingVO.endPage + 1)"
              v-bind:data-page="pagingVO.endPage + 1"
              class="page_select next_page"
              >다음페이지 이동</a
            >
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getSelected" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
  </section>
</template>

<script>
import { getAllUserList } from "@/api/user";
import { getGroupDetail, saveEmailGroup, saveGroupUser } from "@/api/mail";
import CommonModal from "@/components/modal/CommonModal";
export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      groupId: "",
      emailGroup: {},
      groupUserList: "",
      mgmtUser: "",
      form: {
        searchType: "",
        searchWord: "",
        searchEmailUserYn: "Y",
        page: 1,
      },
      pagingVO: "",
      confirmYN: false,
      checkUserAll: false,
      checkAll: false,
      deleteList: [],
      showModal: false,
    };
  },
  methods: {
    async fetchData() {
      try {
        this.groupId = this.$route.params.groupId;
        const { data } = await getGroupDetail(this.groupId);
        this.emailGroup = data.emailGroup;
        // group user 정보
        this.groupUserList = data.groupUserList;
      } catch (error) {
        console.log(error);
      }
    },
    // 이메일 그룹 수정
    async saveEmailGroup() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        this.emailGroup.crudType = "U";
        const { data } = await saveEmailGroup(this.emailGroup);
        if (data.message == null) {
          if (data.status) {
            alert(this.$t("alert.savedSuccessfully"));
            this.fetchData();
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } else {
          alert(this.$t("alert.plzCheckAllValues"));
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 그룹 유저 추가 모달
    async addGroupUser() {
      try {
        const { data } = await getAllUserList(this.form);
        this.mgmtUser = data.pagingVO.dataList;
        this.pagingVO = data.pagingVO;
        this.showModal = true;
      } catch (err) {
        console.log(err);
      }
    },
    closeModal() {
      this.form.searchWord = "";
      this.form.searchType = "";
      this.checkAll = false;
      this.showModal = false;
    },
    // user 검색
    searchBtn() {
      this.form.page = 1;
      this.checkAll = false;
      this.addGroupUser();
    },
    // 페이지 클릭 시
    searchPage(page) {
      this.checkAll = false;
      this.form.page = page;
      this.addGroupUser();
    },
    // 그룹 유저 테그 리스트에서 제거
    async deleteGroupUser() {
      if (!confirm(this.$t("alert.delete"))) return;
      for (let i in this.groupUserList) {
        if (this.groupUserList[i].selected) {
          this.groupUserList[i].crudType = "D";
          this.groupUserList[i].groupId = this.groupId;
        }
      }
      try {
        const { data } = await saveGroupUser(this.groupUserList);
        if (data.status) {
          alert(this.$t("alert.deletedSuccessfully"));
          this.fetchData();
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (error) {
        console.log(error);
      }
      this.checkUserAll = false;
    },
    // 그룹 유저 추가/삭제
    async saveGroupUser() {
      this.confirmYN = confirm(this.$t("alert.save"));
      if (this.confirmYN) {
        try {
          const { data } = await saveGroupUser(this.groupUserList);
          if (data.status) {
            alert(this.$t("alert.savedSuccessfully"));
            this.fetchData();
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    // 기존 유저 전체 체크
    goUserCheckAll(checked) {
      this.checkUserAll = checked;
      console.log(this.checkUserAll);
      for (let i in this.groupUserList) {
        this.groupUserList[i].selected = this.checkUserAll;
      }
    },
    // 모달 유저 전체 체크
    goCheckAll(checked) {
      this.checkAll = checked;
      for (let i in this.mgmtUser) {
        this.mgmtUser[i].selected = this.checkAll;
      }
    },
    //선택한 메뉴 기존 리스트에 추가
    getSelected() {
      // 선택한 사용자 중에 중복 제거
      for (let i in this.groupUserList) {
        for (let j in this.mgmtUser) {
          console.log(this.groupUserList[i]);
          console.log(this.mgmtUser[j]);
          if (
            this.mgmtUser[j].selected &&
            this.groupUserList[i].userId == this.mgmtUser[j].userId
          ) {
            alert(this.$t("alert.aUserAlreadyAddedExists"));
            return;
          }
        }
      }
      // 중복 없을 시 추가
      for (let i in this.mgmtUser) {
        if (this.mgmtUser[i].selected) {
          this.mgmtUser[i].crudType = "I";
          this.mgmtUser[i].roleId = this.roleId;
          this.mgmtUser[i].groupId = this.groupId;
          this.groupUserList.push(this.mgmtUser[i]);
        }
        this.mgmtUser[i].selected = false;
      }
      this.form.searchWord = "";
      this.form.searchType = "";
      this.checkAll = false;
      this.showModal = false;
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped></style>
